module.exports = __webpack_public_path__ + "img/telkomsel-logo.eb1a9efb.png";